<template>
  <div class="c-form-item-depot-code-input-2">
    <div class="body">
      <el-input
        type="textarea"
        v-model="inputValue"
        :rows="4"
        :disabled="disabled"
        resize="none"
        :placeholder="placeholder"
        @keyup="handleKeyup"
        @blur="handleBlur"
      />
    </div>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { ref, onMounted } from '@zto/zpage'
import { useMessage } from '@zto/zpage-ui-element'
import type { GenericObject } from '@zto/zpage'

interface Props {
  model: GenericObject
  label: string
  prop: string
  placeholder: string
  maxLines: number // 支持最大条数
  disabled: boolean
}

const props = withDefaults(defineProps<Props>(), {
  label: '门店编号',
  prop: 'depotCode',
  placeholder: '请输入门店编号，多个门店编号换行输入，最大支持1000个',
  maxLines: 1000,
  disabled: false
})

const inputValue = ref<string | Array<string>>(props.model[props.prop])

const innerInputType = ref<string>(props.prop)

// textarea内enter换行，阻止冒泡
function handleKeyup(e: KeyboardEvent) {
  e.stopPropagation()
}

// 清空
function handleClear() {
  inputValue.value = ''
  triggerChange()
}

// 失焦
function handleBlur() {
  triggerChange()
}

// 过滤空格，最大条数限制&过滤
function triggerChange() {
  let inputArr = inputValue.value
    .split('\n')
    .map(it => it.trim())
    .filter(it => !!it)

  // 验证最大条数
  const { Message } = useMessage()
  let length = inputArr.length
  if (length > props.maxLines) {
    Message.error(`数量超过${props.maxLines}条，按${props.maxLines}条查询`)
    inputArr = inputArr.slice(0, props.maxLines)
    inputValue.value = inputArr.join('\n')
  }

  props.model[innerInputType.value] = inputArr
}

onMounted(() => {
  if (props.model[props.prop]) {
    triggerChange()
  }
})
</script>

<style lang="scss" scoped>
.c-form-item-depot-code-input-2 {
  // height: 80px;

  & > .header {
    display: flex;
    margin-bottom: 10px;
  }

  .name {
    flex: 1;
  }
}
</style>
